'use client';

import { useEffect } from 'react';

/**
 * Root-level (catastrophic) error boundary. Next renders this when an error
 * escapes the root layout, so it REPLACES the layout and must supply its own
 * <html>/<body>. The layout's stylesheet isn't guaranteed here, so styles are
 * inlined — kept on-brand (navy #17165A on the #F7F7F8 base).
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[global error]', error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#F7F7F8',
          fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
          padding: '2rem',
        }}
      >
        <div style={{ textAlign: 'center', maxWidth: '32rem' }}>
          <p style={{ fontSize: '3.5rem', fontWeight: 700, color: '#17165A', margin: 0 }}>Oops</p>
          <h1 style={{ fontSize: '1.6rem', fontWeight: 600, color: '#0F0F0F', margin: '1rem 0 0.5rem' }}>
            Something went wrong
          </h1>
          <p style={{ color: '#4B4B4B', margin: '0 0 1.75rem' }}>
            A critical error occurred. Please reload the page — if it keeps happening, try again in a
            few minutes.
          </p>
          <button
            onClick={() => reset()}
            style={{
              padding: '0.7rem 1.6rem',
              borderRadius: '0.5rem',
              border: 'none',
              background: '#17165A',
              color: '#fff',
              fontWeight: 600,
              fontSize: '0.95rem',
              cursor: 'pointer',
            }}
          >
            Reload
          </button>
        </div>
      </body>
    </html>
  );
}
